import React from "react";

export default function EasterFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".clse3-1{fill:#da582e}.clse3-2{fill:#1b1b36}.clse3-3{fill:#dd572e}"
            }
          </style>
        </defs>
        <path
          className="clse3-1"
          d="M999.81 1804.68A842.56 842.56 0 0 1 671.93 186.2a842.56 842.56 0 0 1 655.76 1552.28 837 837 0 0 1-327.88 66.2Zm0-1668.68c-455.65 0-826.34 370.7-826.34 826.34s370.69 826.34 826.34 826.34 826.34-370.68 826.34-826.34S1455.45 136 999.81 136Z"
        />
        <path
          className="clse3-1"
          d="M959.62 1800.68A838.56 838.56 0 0 1 633.3 189.88a838.56 838.56 0 0 1 652.64 1544.92 833.22 833.22 0 0 1-326.32 65.88Zm0-1668.68c-457.85 0-830.34 372.49-830.34 830.34s372.49 830.34 830.34 830.34S1790 1420.19 1790 962.34 1417.47 132 959.62 132Z"
        />
        <path
          className="clse3-1"
          d="M1031.38 1800.68a838.56 838.56 0 0 1-326.32-1610.8A838.56 838.56 0 0 1 1357.7 1734.8a833.22 833.22 0 0 1-326.32 65.88Zm0-1668.68C573.53 132 201 504.49 201 962.34s372.49 830.34 830.34 830.34 830.34-372.49 830.34-830.34S1489.23 132 1031.38 132Z"
        />
        <path
          className="clse3-2"
          d="M1684 1477.73c-24.74 82.39-133.77 106.57-145.55 109-3.65-16.09-15.4-76.92 20.7-130.3 29.1-43 88-79 114.72-61.69 20.97 13.62 17.89 57.18 10.13 82.99ZM1433.14 1548.09c26.68 70.11-35.86 144.77-42.71 152.72-11.07-9.19-51.51-45-54.92-101.1-2.75-45.22 18.83-101.4 46.55-103.61 21.72-1.74 42.72 30.02 51.08 51.99Z"
        />
        <path
          className="clse3-3"
          d="M1409.27 1621.31c12 31.43-16.07 64.89-19.14 68.46-5-4.12-23.09-20.17-24.62-45.32-1.23-20.27 8.44-45.45 20.86-46.45 9.74-.77 19.16 13.46 22.9 23.31Z"
        />
        <path
          className="clse3-2"
          d="M1332.44 1629.79c43.25 11 58.19 67 59.72 73-8.26 2.24-39.53 9.67-68-7.86-23-14.13-42.91-43.85-34.51-58.1 6.6-11.12 29.24-10.48 42.79-7.04ZM1511.94 1533.29c24.69 12.28 30.23 46.52 30.78 50.21-5 .15-23.69.12-39.35-13.88-12.62-11.28-22.61-31.11-16.87-38.15 4.5-5.47 17.71-2.03 25.44 1.82ZM1626.22 1685.9c-48.36-57.93-144.93-36.43-155.31-34 2.58 14.52 14 68.65 61.56 98.59 38.35 24.14 98.39 31.28 114.08 7 12.29-19.03-5.19-53.44-20.33-71.59Z"
        />
        <path
          className="clse3-3"
          d="M1545.31 1671.46c-20.27-24.29-60.77-15.27-65.12-14.24 1.08 6.09 5.86 28.79 25.81 41.34 16.09 10.13 41.26 13.12 47.84 2.93 5.16-7.99-2.17-22.41-8.53-30.03Z"
        />
        <path
          className="clse3-2"
          d="M1424.17 1821.48c-28.49-69.88-127-78.7-137.67-79.5-2 14.62-7.51 69.65 28.74 112.62 29.22 34.64 84.26 59.66 106.58 41.26 17.49-14.41 11.28-52.49 2.35-74.38ZM1540.11 1650.54c-27 20.11-66.85 2.29-71.12.31 2.61-5.9 13.1-27.74 36.88-36.09 19.17-6.73 46.05-4.31 50.4 7.37 3.42 9.16-7.71 22.12-16.16 28.41Z"
        />
        <path
          className="clse3-3"
          d="M1367.35 1791.07c-14.31-35.09-63.81-39.52-69.16-39.93-1 7.34-3.77 35 14.44 56.57 14.68 17.4 42.32 30 53.54 20.73 8.83-7.24 5.66-26.37 1.18-37.37Z"
        />
        <path
          className="clse3-2"
          d="M1170.73 1764.71c-5.36 0-8.29-.18-8.42-.19a3 3 0 0 1 .4-6c.52 0 53.57 3.17 127.8-18.65 68.47-20.12 169.5-66.21 262-171.53a3 3 0 0 1 4.51 4c-41.28 47-87.69 86.38-138 117a533 533 0 0 1-127.1 56.42c-57.92 16.96-103.2 18.95-121.19 18.95Z"
        />
        <path
          className="clse3-3"
          d="M1610.18 1528.17c-11.62 38.7-62.83 50.06-68.37 51.21-1.71-7.55-7.23-36.13 9.73-61.2 13.67-20.22 41.32-37.13 53.88-29 9.85 6.41 8.4 26.87 4.76 38.99Z"
        />
        <path
          className="clse3-2"
          d="M1632.58 1570.84c-38.26-23.86-88.12 9.75-93.45 13.46 4.25 8 21.11 37.63 53.52 45.08 26.12 6 61.09-2.75 65.16-20.53 3.19-13.94-13.24-30.54-25.23-38.01ZM1351.59 1770c-30.27 10.94-61.85-16.43-65.22-19.42 4-4.68 19.68-21.78 43.77-22.84 19.42-.85 43.37 8.8 44.12 20.71.59 9.36-13.18 18.15-22.67 21.55ZM322 1410.74c13.44 85 118.23 123.58 129.58 127.59 5.77-15.45 25.59-74.15-3-131.9-23.06-46.56-76.55-90.15-105.39-76.55-22.56 10.66-25.36 54.24-21.19 80.86ZM561.18 1514.17c-35.86 65.89 16.07 148.28 21.79 157.08 12.2-7.62 57.1-37.67 68-92.8 8.8-44.44-5-103-32.19-108.93-21.28-4.64-46.37 24.01-57.6 44.65Z"
        />
        <path
          className="clse3-3"
          d="M575 1589.93c-16.08 29.54 7.2 66.47 9.77 70.42 5.47-3.42 25.59-16.89 30.48-41.6 4-19.92-2.25-46.18-14.43-48.83-9.55-2.08-20.82 10.76-25.82 20.01Z"
        />
        <path
          className="clse3-2"
          d="M650 1608.67c-44.33 5.09-66.66 58.55-69 64.34 7.88 3.34 37.87 14.9 68.43 1.36 24.64-10.92 48.42-37.69 42-52.94-5.03-11.94-27.56-14.35-41.43-12.76ZM485.08 1488.92c-26.11 8.85-36.21 42-37.25 45.61 4.9.82 23.46 3.31 40.86-8.46 14-9.48 26.58-27.79 21.85-35.53-3.71-6.07-17.28-4.39-25.46-1.62ZM351.33 1624.79c55.7-50.91 148.51-16.63 158.46-12.79-4.51 14-23.08 66.14-74.25 89.42-41.25 18.77-101.7 17.77-114-8.42-9.6-20.52 12.34-52.26 29.79-68.21Z"
        />
        <path
          className="clse3-3"
          d="M433.44 1621.35c23.36-21.35 62.27-7 66.45-5.36-1.89 5.89-9.68 27.74-31.14 37.5-17.3 7.87-42.64 7.45-47.79-3.53-4.04-8.61 5.16-21.96 12.48-28.61Z"
        />
        <path
          className="clse3-2"
          d="M533.32 1786.28c37.62-65.41 136.46-60.9 147.11-60.27 0 14.75-1.93 70-43.62 107.74-33.61 30.4-91.51 47.79-111.16 26.56-15.39-16.63-4.12-53.53 7.67-74.03ZM441.4 1601.32c24 23.55 65.94 11.25 70.44 9.86-1.79-6.2-9.25-29.25-31.69-40.72-18.1-9.24-45.06-10.46-50.94.53-4.61 8.62 4.67 22.95 12.19 30.33Z"
        />
        <path
          className="clse3-3"
          d="M593.71 1763.8c18.9-32.86 68.55-30.6 73.9-30.28 0 7.41-1 35.18-21.91 54.12-16.88 15.27-46 24-55.84 13.34-7.73-8.35-2.07-26.89 3.85-37.18Z"
        />
        <path
          className="clse3-2"
          d="M800.67 1765.05h-.21c-.54 0-54.38-4.08-125.92-36a533.29 533.29 0 0 1-118.36-73c-45.69-37.09-86.39-82.33-121-134.47a3 3 0 1 1 5-3.31c77.46 116.78 171.38 176 236.52 205.18 70.62 31.59 123.62 35.61 124.14 35.64a3 3 0 0 1-.2 6Z"
        />
        <path
          className="clse3-3"
          d="M388.42 1470.64c6.31 39.91 55.53 58 60.86 59.94 2.71-7.26 12-34.83-1.41-62-10.83-21.87-35.95-42.34-49.5-35.95-10.62 5.04-11.93 25.51-9.95 38.01Z"
        />
        <path
          className="clse3-2"
          d="M360.49 1509.91c41.12-18.5 86 21.51 90.8 25.9-5.3 7.39-26 34.45-59.1 37.48-26.7 2.44-60.17-10.93-61.81-29.1-1.29-14.19 17.22-28.48 30.11-34.28ZM612.16 1745.06c28.52 14.91 63.5-8 67.23-10.48-3.35-5.18-16.57-24.23-40.3-28.51-19.13-3.46-44.16 2.89-46.5 14.59-1.84 9.17 10.63 19.73 19.57 24.4Z"
        />
        <path
          className="clse3-3"
          d="M1278.29 1638.21c-14.17 22.07-44.55 26.7-59 27.86q-21.32 100.37-42.61 200.74c16.24 5.89 25.85 21.21 23.76 35.23-2.42 16.23-23.88 25.49-40.15 25.4a45.88 45.88 0 0 1-20.88-5.43c-31.8-17.26-31.63-69.87-31.56-74l-64.73 35.23c2.72.64 27.79 6.76 29.5 20.49.76 6.11-3.43 11.28-4.92 13.11-14.67 18-70 28.15-140.11 15.57a399.29 399.29 0 0 1-118.8-41.79c-3.1 5.15-11.92 18.2-27.87 22.94-26 7.72-57-10.7-64.72-36.87-.65-2.17-7.78-27.89 9.83-45.89 12.86-13.15 30.11-13.18 33.59-13.11-4.06-17.07-20.94-96.07 25.4-163.87 52.23-76.42 163.63-107.68 269.57-68a118.74 118.74 0 0 1 13.16-51.26c-19.81-11.82-41.48-33.55-55.07-50-33.93-41-62.86-103.79-47.79-116.38 14.62-12.22 66.47 26.27 95.12 55.62 1.69 1.73 6.25 6.45 12 13.16a312.75 312.75 0 0 1 13 16.16c-.86-3.8-1.62-7.43-2.26-10.84-9.74-52.33-4.51-121.25 14.78-125 18.71-3.57 45.34 55.27 56.12 94.84 1.65 6.08 10.45 39.48 9.57 70.06 2.71.38 5.36.86 8 1.43 26.6 5.85 47.2 21.17 54.65 26.73 39.83 29.72 75.96 91.2 52.42 127.87Z"
        />
        <path
          className="clse3-2"
          d="M1085 1453.12c-.34-1.48-.76-3.37-1.21-5.57 0 0-.56-2.64-1-5.27-9.74-52.33-4.51-121.25 14.78-125 18.71-3.57 45.34 55.27 56.12 94.84 1.65 6.08 10.45 39.48 9.57 70.06a61.63 61.63 0 0 0-24.46-1 62.28 62.28 0 0 0-30.47 14.31 261.72 261.72 0 0 0-19.6-36.83c-1.25-1.86-2.47-3.72-3.73-5.54ZM798.78 1882.21c-1.25 15.72-20.8 23.52-33.24 24.49-19.31 1.51-38.13-12.14-43.73-29.73-7.23-22.71 10.17-43.86 10.5-43.73s-8.58 15-5.25 33.23c.39 2.12 3.31 18.13 10.5 19.24 10.41 1.62 15.51-30.23 32.36-32.36 12.42-1.57 30.08 13.18 28.86 28.86ZM1184.46 1883.09c7.26 6.28 5.76 17.38 2.63 23.61-5.4 10.75-19.11 13.92-28.86 12.25-14.8-2.54-23.45-16.74-22.47-17.93s15.32 12.37 21.59 8.31c6-3.86-2.51-19 5-26.49 5-4.92 15.71-5.3 22.11.25Z"
        />
        {children}
      </g>
    </svg>
  );
}
